<template>
  <el-dialog
    class="cipher-detail-dialog common-dialog"
    :close-on-click-modal="false"
    :visible.sync="dialogVisible"
    :before-close="handleCancel"
    :title="title"
  >
    <div class="decrypt-con">
      {{ decrypt_result }}
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'CiphertextDetail',
  data() {
    return {
      title: '数据详情',
      dialogVisible: false,
      decrypt_result: ''
    }
  },
  mounted() {},
  methods: {
    handleCancel() {
      this.dialogVisible = false
    },
    handleOpen(data) {
      this.decrypt_result = data.data.decrypt_result

      this.dialogVisible = true
    },

    submitForm(row) {
      this.$apis.chain
        .createUser(this.ruleForm)
        .then(res => {
          if (res.data.data) {
            this.$message.success('新增用户成功')
            this.handleCancel()
          } else {
            this.$message.success('该用户没有权限访问')
          }
        })
        .catch(err => {
          return
        })
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';

@include theme('cipher-detail-dialog', (), ());
.cipher-detail-dialog.common-dialog {
  @include adaptation((
    --cipher-detail-dialog-body-padding-bottom: 20px,
    --cipher-detail-dialog-content-height: 260px
  ));
  /deep/ .el-dialog {
    width: var(--common-dialog-medium-width);

    .el-dialog__body {
      padding-bottom: var(--cipher-detail-dialog-body-padding-bottom);
    }
  }

  .decrypt-con {
    height: var(--cipher-detail-dialog-content-height);
    overflow-y: auto;
  }
}
</style>
